/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Info_LegalInputs */

const en_footer_info_legal = /** @type {(inputs: Footer_Info_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal Info`)
};

/**
* | output |
* | --- |
* | "Legal Info" |
*
* @param {Footer_Info_LegalInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_info_legal = /** @type {((inputs?: Footer_Info_LegalInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Info_LegalInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_info_legal(inputs)
});